/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { useTranslation } from 'react-i18next'
import Slider from 'rc-slider'
import { useDispatch, useSelector } from 'react-redux'

import 'rc-slider/assets/index.css'
import * as s from './SalaryRange.styles'
import { setSalaryRange } from '../../../../../../redux/reducers/talentSlice'

const { createSliderWithTooltip } = Slider
const Range = createSliderWithTooltip(Slider.Range)

const propTypes = {}

const defaultProps = {}

/**
 * Allows user to update his salary range preference
 */
function SalaryRange() {
  const dispatch = useDispatch()
  const { t } = useTranslation(['talentArea'], {
    useSuspense: false,
  })
  const { salaryRange } = useSelector((state) => state.talent)

  return (
    <s.SalaryWrapper>
      <label className="field-label" style={{ marginBottom: '60px' }}>
        {t('talentArea:profile.salary.label')}
      </label>
      <div className="sliderArea">
        <Range
          marks={{
            0: `0K`,
            200: `200K`,
          }}
          min={0}
          max={200}
          onAfterChange={(e) => {
            const salaryRangeObject = {
              minValue: e[0],
              maxValue: e[1],
            }
            dispatch(setSalaryRange(salaryRangeObject))
          }}
          defaultValue={[salaryRange?.minValue, salaryRange?.maxValue]}
          tipFormatter={(value) => `${value}K`}
          allowCross={false}
          tipProps={{
            placement: 'top',
            visible: true,
          }}
        />
      </div>
    </s.SalaryWrapper>
  )
}

SalaryRange.propTypes = propTypes
SalaryRange.defaultProps = defaultProps

export default SalaryRange
